import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNServiceCode } from './cnservicecode';

@RegisterItem()
export class CNServiceCodeCustom extends CNServiceCode {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNServiceCode.CNServiceCodeCustom';
    }

    get price(): string {
        return this.getProperty('price');
    }

    set price(aPrice: string) {
        this.setProperty('price', aPrice);
    }

    get description(): string {
        return this.getProperty('description');
    }

    set description(aDesc: string) {
        this.setProperty('description', aDesc);
    }

    public clone(): any {
        return new CNServiceCodeCustom();
    }
}
